import styled from 'styled-components';
import media from 'styled-media-query';

export const PageWrapper = styled.div`
    display: flex;
	flex-direction: column;
	min-height: 100vh;
`;

export const ContentList = styled.div`
    display: grid;
    grid-gap: 1rem;
    margin-bottom: 2rem;

	/* ${media.lessThan('medium')`
		flex-direction: column;
	`} */
`;

export const Text = styled.p`
    line-height: 150%;
`;

export const Bold = styled.span`
    font-weight: 600;
`;
export const Bolder = styled.span`
    font-weight: 800;
`;

export const HtmlContent = styled.div`
	margin-bottom: 25px;
	padding-bottom: 25px;
	overflow-x: hidden;

	.ql-size-small{font-size: .75em;}
	.ql-size-large{font-size: 1.5em;}
	.ql-size-huge{font-size: 2.5em;}
	strong{font-weight: bold;}
	em{font-style: italic;}
	sub{vertical-align: sub; font-size: smaller;}
	sup{vertical-align: super; font-size: smaller;}
	blockquote{border-left: 4px solid #ccc; margin-bottom: 5px; margin-top: 5px; padding-left: 16px;}
	ol{list-style: decimal; padding-left: 1.5em;}
	ul{list-style: disc; padding-left: 1.5em;}

	.ql-direction-rtl{direction: rtl;}
	.ql-align-right{text-align: right;}
	.ql-align-center{text-align: center;}
	.ql-align-left{text-align: left;}
	.ql-align-justify{text-align: justify;}

	a{color: #06c; text-decoration: underline;}
    p{margin-bottom: 16px;}
	img{max-width: 100% !important;}
	iframe{width: 100%; max-width: 560px !important; height: 360px !important;}
`;

// Policies and Terms
export const Title = styled.h1`
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
`;

export const Subtitle = styled.h2`
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
`;

export const Paragraph = styled.div`
    margin-bottom: 2.5rem;
`;

export const Sentence = styled.p`
    margin-bottom: 1rem;
    margin-left: ${({ left }) => left || '0'};
`;

